import Widget from './Widget';
export type { WidgetProps } from './Widget.types';

export default Widget;
